import {AfterViewInit, Component, signal} from '@angular/core';
import {ComponentEntity, TypeComponent} from "../../entities/component-entity";
import {ActivatedRoute} from "@angular/router";
import {CacheService} from "../../services/cache.service";
import {
  ApplicantProject,
  ApplicantProjectLayout, createPropertiesForView,
  createSectionView,
  SectionView
} from "../../entities/projects.entities";
import {MatDialog} from "@angular/material/dialog";
import {DialogVideoComponent} from "../../dialog-video/dialog-video.component";
import {ListSectionComponentsComponent} from "../list-section-components/list-section-components.component";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-view',
  standalone: true,
  imports: [
    ListSectionComponentsComponent,
    NgIf
  ],
  templateUrl: './view.component.html',
  styleUrl: './view.component.css'
})
export class ViewComponent implements AfterViewInit{

  body = signal<SectionView>(createSectionView())
  header = signal<SectionView >(createSectionView())
  footer = signal<SectionView>(createSectionView())

  // getter que calcula la clase de altura mínima
  get sectionMinHeight(): string {
    const hasHeader = this.header().components.length > 0;
    const hasFooter = this.footer().components.length > 0;

    if (hasHeader && hasFooter)   return 'min-h-[800px]';
    if (hasFooter)   return 'min-h-[700px]';
    return 'min-h-[800px]';
  }
  constructor(private route: ActivatedRoute,private cacheService:CacheService,private dialog: MatDialog) {

    let uuidView = this.route.params.subscribe(params => {
      const id = params['id'];
          this.loadData(id)
    })



  }



  public loadData(uuidView:string){
    let views = this.cacheService.get(CacheService.VIEWS) as ApplicantProjectLayout[]
    let app = this.cacheService.get(CacheService.APP_INFORMATION) as ApplicantProject
    let mainView =
      views.find(view => {
        return view.id === uuidView;
      })

    if(mainView?.mainView && app.preconfiguration.welcomeVideo !== ""){
      this.dialog.open(DialogVideoComponent, {
        width: '800px',
        data: { videoUrl: app.preconfiguration.welcomeVideo } // URL del video
      });
    }
    this.body.set( {
      components : mainView?.component ?? [],
      properties : mainView?.properties ?? createPropertiesForView()
    })
    this.header.set(mainView?.header ?? createSectionView())
    this.footer.set(mainView?.footer ?? createSectionView())
  }
  ngAfterViewInit(): void {
    }


  protected readonly TypeComponent = TypeComponent;
}
